import { STATUS_MAPPING } from "./config";

export const getRecipients = (news) => {
  return news?.recipients_flg === 1
    ? ["All citizens"]
    : news?.wards?.map((ward) => `${ward?.ward_code} - ${ward?.region_name}`);
};

export const formatBasicDetails = (selectedArticle) => {
  const fullName = selectedArticle
    ? `${selectedArticle.first_name} ${selectedArticle.last_name}`
    : "Name not available";

  return [
    {
      key: "Status",
      value: [STATUS_MAPPING[selectedArticle?.project_status_flg]],
      chip: true,
    },
    {
      key: "Ward",
      value: selectedArticle?.ward_code,
    },
    {
      key: "Councillor",
      value: fullName,
      // avatar: true,
      counsilor: true,
    },
    {
      key: "Author",
      value: selectedArticle?.created_user_name,
      avatar: true,
    },

    {
      key: "Created date",
      value: selectedArticle?.created_date && selectedArticle?.created_date,
    },
  ];
};

const getNewsStatus = (type) => {
  switch (type) {
    case "reject":
      return 3;
    case "schedule":
      return 2;
    case "publish":
      return 4;
    default:
      return 0;
  }
};

export const createNewsForm = (selectedArticle, type) => {
  return {
    news_id: selectedArticle?.id,
    status: getNewsStatus(type),
  };
};
